module.exports = __webpack_public_path__ + "static/web-app-solutions-e6329c72bcca0677b86df2d19f2d8481.png";